<template>
  <div ref="projectTableWrapper" class="project-table-wrapper" style="height:auto">
    <el-tabs v-model="activeTab" type="card" size="mini" @tab-click="changeActiveTab">
      <el-tab-pane v-for="item in tabTypes" :key="item.type" :label="item.label" :name="item.type">
        <!-- <span slot="label">{{ item.label }}</span> -->
      </el-tab-pane>
      <el-tab-pane label="排序" name="排序">
        <div slot="label" class="sort-item" @click.stop>
          <span class="label" style="width:60px">排序：</span>
          <div
            v-for="v in ['优先级', '创建时间']"
            :key="v"
            class="radish-search-tag"
            :class="{ 'radish-search-tag-active': sortType === v }"
            @click="changeSortType(v)"
          >
            {{ v }}
          </div>
        </div>
        <!-- <span slot="label">{{ item.label }}</span> -->
      </el-tab-pane>
    </el-tabs>

    <div v-if="tableType === '阶段模式'" v-loading="loading" class="new-project-list-box">
      <ProjectListDeatil
        v-for="(item, index) in list"
        :key="item._id"
        :get-pipeline="getPipeline"
        :project="item"
        :show-dropdown="showDropdown"
        :show-step="showStep"
        :show-radish-search-mark="showRadishSearchMark"
        :show-position-recommend-mark="showPositionRecommendMark"
        @updateProject="param => updateProject(item, index, param)"
      ></ProjectListDeatil>
    </div>
    <div v-else-if="tableType === '列表模式'" v-loading="loading" class="new-project-list-box">
      <NewProjectTableTypeList
        :get-pipeline="getPipeline"
        :projects="list"
        :simple="false"
        :show-dropdown="showDropdown"
        @updateProject="param => updateProject(item, index, param)"
      ></NewProjectTableTypeList>
    </div>

    <el-pagination
      class="new-project-pagination"
      :current-page="page"
      :page-sizes="[100, 200, 300]"
      :page-size="pageSize"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    />
    <!-- 进度弹窗 -->
    <!-- <ProjectProgressDialog ref="ProjectProgressDialog" @reloadProject="reloadProject"></ProjectProgressDialog> -->
    <OldProjectProgressDialog ref="OldProjectProgressDialog"></OldProjectProgressDialog>
    <!-- 人才搜寻叹号弹窗 -->
    <NewProjectRadishSearchDialog ref="NewProjectRadishSearchDialog"></NewProjectRadishSearchDialog>
    <!-- 职位推荐叹号弹窗 -->
    <NewPositionRecommendDialog ref="NewPositionRecommendDialog"></NewPositionRecommendDialog>
    <!-- poper -->
    <Popper
      id="project-list-deatil"
      :visible.sync="popperVisible"
      :target-id="popperTarget"
      container="projectTableWrapper"
      class-name="shadow"
    >
      <div v-if="popperType === 'dropdown'" class="dropdown-popper">
        <a :href="`#/project20/${project.pid || project._id}`" class="item" target="_blank">进入项目</a>
        <!-- <div class="item" @click="onePiece('项目列表', '项目列表')">生成悬赏</div> -->
        <div class="item" @click="generatePic(project)">生成图片</div>
        <div class="item">
          添加人选 <i class="el-icon-arrow-right" />
          <div class="sub-item shadow">
            <div class="item" @click="addRadish">添加项目人选</div>
            <!-- <div class="item" @click="openDrawer('radish')">从人才库选人</div>
            <div class="item" @click="openDrawer('project')">从同类项目选人</div>
            <div class="item" @click="openDrawer('targetCompany')">从目标公司选人</div> -->
            <div class="item" @click="oneKeyMatch('1')">一键匹配</div>
            <div class="item" @click="oneKeyMatch('2')">二键匹配</div>
            <div class="item" @click="oneKeyMatch('3')">三键匹配</div>
            <div class="item" @click="recommendMatch(project)">智能匹配</div>
          </div>
        </div>
        <!-- <div class="item" @click="openDrawer('finalRadish')">项目复盘</div> -->
        <el-popover v-model="projectReportShow" placement="right" width="800" trigger="click">
          <div>
            <p>
              请点击勾选O，选择你要使用的项目报告类型：<peixun
                type="10"
                style="display:inline-block;margin-left:5px;position:relative;top:3px;"
              ></peixun>
            </p>
            <div class="flex-row">
              <div class="col-1 pd10" @click="reportType = 'mapping'">
                <el-radio v-model="reportType" label="mapping">人选mapping报告</el-radio>
                <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
                <div><img src="../../../assets/images/project_mapping.png" class="img_max" /></div>
              </div>
              <div class="col-1 pd10" @click="reportType = 'report'">
                <el-radio v-model="reportType" label="report">搜索进度报告</el-radio>
                <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
                <div><img src="../../../assets/images/project_report.png" class="img_max" /></div>
              </div>
            </div>
            <div class="text_right">
              <!-- <a :href="`#/project/${project.pid || project._id}/${reportType}`" class="btn_default" target="_blank"
                >生成报告</a
              > -->
              <span class="btn_default" @click="getReport">生成报告</span>
            </div>
          </div>
          <div slot="reference" class="item" @click="generateProjectReport">生成项目报告</div>
        </el-popover>
        <div class="item">
          项目状态 <i class="el-icon-arrow-right" />
          <div class="sub-item shadow">
            <div v-for="val in getProjectStatus()" :key="val" class="item" @click="modifyProjectStatus(val)">
              {{ val }}
            </div>
          </div>
        </div>
        <div class="item" @click="copyProject">复制项目</div>
        <div class="item" @click="editPartners">项目成员</div>
        <div class="item" @click="pushToYuanshou">发布为微名片职位</div>
        <div v-if="showDeskfollowBtn()" class="item" @click="deleteDesktopFollow">取消本周重点</div>
        <div v-else class="item" @click="addDesktopFollow">设置为本周重点</div>
        <div v-if="canRemove" class="item ft-danger" @click="removeProject(project.pid || project._id)">删除</div>
      </div>
    </Popper>
    <!-- 修改项目成员 -->
    <EditProjectPartner ref="EditProjectPartner"></EditProjectPartner>
    <!-- 发布为圆手职位 -->
    <pushToYuanshou ref="pushToYuanshou"></pushToYuanshou>
    <weimingpianAuth ref="weimingpianAuth" @changeBind="changeBind"></weimingpianAuth> <generatePic ref="generatePic" />
  </div>
</template>

<script>
import ProjectListDeatil from './ProjectListDeatil'
import OldProjectProgressDialog from './ProjectProgressDialog'
// import ProjectProgressDialog from './projectProgress/NewProjectProgressDialog'
import Popper from './Popper.vue'
import { onePiece, oneKeyMatch, recommendMatch, removeProject } from '../constant/utils'
import NewProjectRadishSearchDialog from './NewProjectRadishSearchDialog.vue'
import NewPositionRecommendDialog from './NewPositionRecommendDialog'
import EditProjectPartner from './projectProgress/EditProjectPartner'
import pushToYuanshou from './pushToYuanshou/pushToYuanshou'
import weimingpianAuth from '../../../misc/src/dialog/weimingpianAuth'
import generatePic from '../dialog/generatePic.vue'
import NewProjectTableTypeList from './NewProjectTableTypeList.vue'

const dateFormat = require('dateformat')

export default {
  components: {
    ProjectListDeatil,
    Popper,
    // ProjectProgressDialog,
    NewProjectRadishSearchDialog,
    OldProjectProgressDialog,
    NewPositionRecommendDialog,
    EditProjectPartner,
    pushToYuanshou,
    weimingpianAuth,
    generatePic,
    NewProjectTableTypeList,
  },
  props: {
    tableType: { type: String, default: '阶段模式' },
  },
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 100,
      total: 0,
      query: {},
      loading: false,
      getPipeline: false,
      sort: { createdAt: -1 },
      activeTab: '我关注的',
      tabTypes: [
        { type: '全部', label: '全部（已参与的）' },
        { type: '客户开发', label: '客户开发' },
        { type: '项目对接', label: '项目对接' },
        { type: '项目经理', label: '项目经理' },
        { type: '项目成员', label: '项目成员' },
        { type: '我关注的', label: '本周重点项目' },
        { type: '只读', label: '同组其他项目（只读）' },
      ],
      project: {},
      popperVisible: false,
      popperTarget: '',
      popperType: '',
      reportType: 'mapping',
      sortType: '创建时间',
      projectStatus: ['已成功', '已失败', '进展中', '已暂停'],
      ifBindYuanshou: false,
      projectReportShow: false,
    }
  },
  computed: {
    onePiece() {
      return onePiece
    },
    canRemove() {
      if (!window.app.user) return false
      return (
        (window.app.user['角色'] && window.app.user['角色'].includes('管理员')) ||
        (this.project && this.project['项目经理'] && this.project['项目经理'].includes(window.app.user.account))
      )
    },
    removeProject() {
      return removeProject
    },
  },
  mounted() {
    this.getProjects()
    if (!window.app.user) this.ifBindYuanshou = false
    if (
      window.app.user['开放平台'] &&
      window.app.user['开放平台']['微元科技'] &&
      window.app.user['开放平台']['微元科技'].unionid
    ) {
      this.ifBindYuanshou = true
    }
  },
  methods: {
    async getReport() {
      const { project } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: project.pid || project._id,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(project.pid || project._id)
      }
    },
    async generatePic(project) {
      await app.service('project').saveRecords({ type: '生成图片', path: '顶部导航栏-项目操作', page: '项目详情' })
      this.$refs.generatePic.open(project)
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    pushToYuanshou() {
      if (!this.ifBindYuanshou) {
        this.$confirm('您的账号还未绑定圆手查薪酬小程序,点击确定去绑定', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$refs.weimingpianAuth.open('用户绑定')
          })
          .catch(() => {})
      } else {
        this.$refs.pushToYuanshou.show(this.project)
      }
    },
    changeBind(e) {
      this.ifBindYuanshou = e
      this.$confirm('是否完善个人信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$refs.weimingpianAuth.open('个人信息完善')
        })
        .catch(() => {
          this.$refs.weimingpianAuth.close()
        })
    },
    getProjectStatus() {
      return this.projectStatus.filter(v => v !== this.project.项目状态)
    },
    async modifyProjectStatus(val) {
      if (val === '已成功') {
        const project = await this.getProjectsPipelines([this.project])
        const guobao = ((project[0] && project[0].radish_project) || []).filter(
          v => !v.isDeleted && v.状态 && v.状态.tag === '过保' && !v.状态.detail,
        )
        if (guobao.length === 0) {
          return this.$alert('当前项目无人过保，请先确认', '提示', {
            confirmButtonText: '确定',
            callback: action => {},
          })
        }
      }

      const obj = { 项目状态: val }
      if (val === '已成功') obj.endTime = new Date().getTime()
      this.modify(this.project._id, obj)
      this.$set(this.project, 'endTime', obj.endTime)
      this.$set(this.project, '项目状态', val)
      if (val === '已失败') this.openDrawer('finalRadish', this.project)
    },
    changeSortType(val) {
      this.sortType = val
      this.setQuery(this.query, true)
    },
    editPartners() {
      this.$refs.EditProjectPartner.open(this.project)
    },

    async showStep(project, step) {
      await app.service('project').saveRecords({ type: step, path: '点击项目阶段', page: '项目列表' })
      this.activeStep = step
      if (step === '项目创建') window.open(`${window.origin}/#/project20/${project._id}?defaultActiveTab=详情`)
      else if (step === '人才搜寻') window.open(`${window.origin}/#/project20/${project._id}`)
      else app.root.$refs.NewProjectProgressDialog.open(project, step, this.reloadProject)
    },
    async reloadProject(project) {
      const newProject = await this.getProjectsPipelines([project])
      this.showStep(newProject[0], this.activeStep, this.reloadProject)
    },
    showRadishSearchMark(project) {
      this.$refs.NewProjectRadishSearchDialog.open(project)
    },
    showPositionRecommendMark(project) {
      this.$refs.NewPositionRecommendDialog.open(project)
    },
    updateProject(project, index, change) {
      const newProject = Object.assign(project, change)
      this.list.splice(index, 1, newProject)
    },
    showDropdown(row, targetId) {
      this.project = row
      this.projectReportShow = false
      this.popperVisible = true
      this.popperTarget = targetId
      this.popperType = 'dropdown'
    },
    // dropdown-method
    addRadish() {
      window.app.root.$refs.radishAdd.open({ defaultPid: this.project._id })
    },
    openDrawer(type, project) {
      if (window.app.root.$refs.addRadishDrawer) {
        window.app.root.$refs.addRadishDrawer.openDrawer(type, project || this.project)
      }
    },
    async oneKeyMatch(mode) {
      try {
        await oneKeyMatch({
          mode,
          project: this.project,
          onNoResult: () => {
            this.$message('没有匹配结果')
          },
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async recommendMatch(project) {
      recommendMatch(project)
    },
    copyProject() {
      // window.app.root.$refs.addProjectFull.open(this.project)
      window.open(`${window.frontend}/#/createProject20?copyPid=${this.project._id}`, '_blank')
    },
    showDeskfollowBtn() {
      const { desktopFollow = [] } = this.project
      const account = app.user.account
      const hasFollow = desktopFollow.find(val => val.account === account && val.type === 'project')
      return !!hasFollow
    },
    async deleteDesktopFollow() {
      const res = await app
        .service('company')
        .deleteDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.$message.success('取消关注成功')
        this.project.desktopFollow = []
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async addDesktopFollow() {
      const res = await app
        .service('company')
        .addDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.project.desktopFollow = res.data
        this.$message.success('关注成功')
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    // dropdown-method

    async changeActiveTab(tab) {
      await app.service('project').saveRecords({ type: this.activeTab, path: '切换项目列表类别', page: '项目列表' })
      this.page = 1
      const copyQuery = window._.cloneDeep(this.query)
      const account = app.user.account

      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      if (fields.includes(tab.name)) {
        copyQuery.参与成员 = [{ [tab.name]: account }]
        this.getProjects(copyQuery)
      } else this.getProjects()
      this.$emit('changeActiveTab', this.activeTab)
      // this.activeTab = tab
      // const task = this.tasks.find(val => val._id === tab.name)
      // this.loadData(task)
    },
    async getProjects(setQuery) {
      this.sort = this.sortType === '优先级' ? { 优先级: -1, createdAt: -1 } : { createdAt: -1 }
      if (this.loading) return
      this.loading = true
      const { query } = this
      const param = Object.assign(
        { query: setQuery || query },
        { page: this.page, limit: this.pageSize },
        { sort: this.sort },
      )
      if (this.activeTab === '我关注的') param.isPined = true
      else if (this.activeTab === '只读') param.isReadOnly = true
      await app
        .service('project')
        .saveRecords({ type: '项目搜索', path: '项目列表', page: '项目', data: { 搜索条件: param } })
      try {
        const res = await app.service('project').list(param)
        const { status, msg, data, total } = res
        if (status !== 'success') {
          this.$message.error(msg)
        } else {
          this.list = data
          this.total !== total && (this.total = total)
          this.getPipeline = false
          this.getProjectsPipelines(this.list)
        }
      } catch (error) {
        this.$message.error(`获取项目列表出错了:${error.message}`)
      }
      this.loading = false
    },
    async getProjectsPipelines(projects) {
      if (!projects) return
      try {
        const pids = projects.map(project => project._id)
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids,
        })
        data.forEach(projectPipeline => {
          const project = projects.find(_project => _project._id === projectPipeline._id)
          Object.assign(project, projectPipeline)
        })
        this.getPipeline = true
        return projects
      } catch (e) {
        console.error(e)
      }
    },
    pageChange(val) {
      this.page = val
      this.getProjects()
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.getProjects()
    },
    jumpToCompany() {
      this.openDrawer('targetCompany')
    },
    setQuery(query, sortChange) {
      this.sort = this.sortType === '优先级' ? { 优先级: -1, createdAt: -1 } : { createdAt: -1 }
      if (query) {
        this.query = Object.assign({}, query)
        this.page = 1
        if (this.activeTab !== '全部') {
          if (this.activeTab === '我关注的' && !sortChange) this.activeTab = '全部'
          this.changeActiveTab({ name: this.activeTab })
        } else this.getProjects()
      } else {
        this.query = undefined
      }
    },
    async modify(id, param) {
      if (!id) return
      try {
        await window.app.service('project').modify({ id, param })
        this.$message.success('修改成功')
      } catch (error) {
        this.$message.error(`projectTable modify:${error.message}`)
      }
    },
    moment(date) {
      return date ? dateFormat(new Date(parseInt(date, 10)), 'yyyy-mm-dd') : ''
    },
    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}天` : ''
    },
    mergeRadish(target, radish) {
      target['姓名'] = radish['姓名'] || '--'
      target['性别'] = radish['性别'] || '--'
      target['公司'] = radish['公司'] || '--'
      target['部门'] = radish['部门'] || '--'
      target['目前职位'] = radish['目前职位'] || '--'
      target['手机'] = radish['手机'] || '--'
      target['地域'] = radish['地域'] || '--'
      target['职能模块'] = radish['职能模块'] || '--'
    },
    // handleSort({ column, prop, order }) {
    //   if (!order) {
    //     this.sort = {}
    //   } else {
    //     this.sort = {
    //       [prop || sortKeyFormat[column.label] || column.label]: order === 'ascending' ? 1 : -1,
    //     }
    //   }
    //   this.getProjects()
    // },
    copyProject() {
      window.app.root.$refs.addProjectFull.open(this.project)
    },
    addRadish() {
      window.app.root.$refs.radishAdd.open({ defaultPid: this.project._id })
    },
    openDrawer(type, project) {
      if (window.app.root.$refs.addRadishDrawer) {
        window.app.root.$refs.addRadishDrawer.openDrawer(type, project || this.project)
      }
    },
    async oneKeyMatch(mode) {
      try {
        await oneKeyMatch({
          mode,
          project: this.project,
          onNoResult: () => {
            this.$message('没有匹配结果')
          },
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async showPipelineDetail(type, list) {
      this.pipelineDetailVisible = true
      this.pipelineDetailType = type
      if (!list || list.length === 0) return
      const rids = list.map(val => val.rid).filter(Boolean)
      if (rids.length === 0) return
      const {
        status,
        data: { data },
      } = await window.app.service('radish').list({ query: { _id: rids } })
      if (status !== 'success') return (this.pipelineDetailData = list)
      data.forEach(radish => {
        list.forEach(obj => {
          if (radish._id === obj.rid) {
            this.mergeRadish(obj, radish)
          }
        })
      })
      this.pipelineDetailData = list
    },
    changeYi: async function(row, val) {
      const result = await app.service('radish').modifyYixiang({ rid: row.rid, pid: row.pid, yixiang: val })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    showDeskfollowBtn() {
      const { desktopFollow = [] } = this.project
      const account = app.user.account
      const hasFollow = desktopFollow.find(val => val.account === account && val.type === 'project')
      return !!hasFollow
    },
    async addDesktopFollow() {
      const res = await app
        .service('company')
        .addDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.project.desktopFollow = res.data
        this.$message.success('关注成功')
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async deleteDesktopFollow() {
      const res = await app
        .service('company')
        .deleteDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.$message.success('取消关注成功')
        this.project.desktopFollow = []
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async generateProjectReport() {
      const data = await app.service('project').projectRecommends(this.project._id)
      if (data && data.length > 0) {
        this.projectReportShow = true
      } else {
        this.projectReportShow = false
        this.$message.error(`当前没有推荐人选，请推荐人选之后重试`)
      }
      await app.service('project').saveRecords({ type: '生成项目报告', path: '顶部导航栏-项目操作', page: '项目详情' })
    },
  },
}
</script>

<style scoped>
.project-table-wrapper {
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.new-project-list-box {
  height: calc(100% - 92px);
  overflow: auto;
}
.new-project-pagination {
  position: fixed;
  left: 0;
  bottom: 0;
}
.dropdown-popper {
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.dropdown-popper .item {
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 20px;
  color: #606266;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
}
.dropdown-popper .item:hover {
  color: #fff;
  background: #409eff;
}
.dropdown-popper .item:hover .sub-item {
  display: block;
}
.dropdown-popper .item .sub-item {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
}
.shadow {
  box-shadow: 0px 2px 8px 0px rgba(232, 237, 250, 0.6), 0 2px 4px 2px rgba(232, 237, 250, 0.5);
}
.searchbar-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}
.searchbar-item .label {
  word-break: keep-all;
}
.radish-search-tag {
  display: inline-block;
  padding: 0 7px;
  margin: 2px 5px 2px 0;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  color: #a19fa5;
  word-break: keep-all;
}
.radish-search-tag.radish-search-tag-active {
  background-color: #409eff;
  color: #fff;
}
</style>
